import { ContentType } from './models/ContentType';
import { Invoice } from './models/Invoice';
import { ISsoStore } from './SsoStore';
import { ITranslateStore } from './TranslateStore';

export default class InvoiceNameStore {
  constructor(
    private ssoStore: ISsoStore,
    private translateStore: ITranslateStore
  ) {}

  public invoiceName(invoice: Invoice): string {
    if (!invoice) {
      return null;
    }
    if (invoice.restricted) {
      return invoice.assignedName;
    }
    return this.refNumberName(invoice.contentType, invoice.assignedName, invoice.source);
  }

  public refNumberName(contentType: ContentType, assignedName: string, source: string): string {
    const alwaysShowDefaultName = source === 'TBCIS' && contentType === 'MOBILE' && this.ssoStore.isPrivateCustomer;
    if (alwaysShowDefaultName) {
      return this.defaultInvoiceName(contentType);
    }
    if (assignedName) {
      return assignedName;
    }
    return this.defaultInvoiceName(contentType);
  }

  public defaultInvoiceName(contentType: ContentType): string {
    const translate = this.translateStore.translate;
    switch (contentType) {
      case 'MOBILE':
        return translate('shared.invoices.invoice-name.mobile-service');
      case 'GOODS':
        return translate('shared.invoices.invoice-name.product');
      case 'PERIODIC_INVOICES':
        return translate('shared.invoices.invoice-name.unified');
      case 'STATE_FEES':
        return translate('shared.invoices.invoice-name.state-fees');
      case 'FINANCE':
        return translate('shared.invoices.invoice-name.finance');
      case 'DEBT':
        return translate('shared.invoices.invoice-name.debt');
      case 'TELESERVICES':
        return translate('shared.invoices.invoice-name.teleservices');
      case 'PENALTY':
        return translate('shared.invoices.invoice-name.penalty');
      case 'DAX_REF_NUMBER':
        return translate('shared.invoices.invoice-name.dax-ref-number');
      case 'MASTER_REF_NUMBER':
        return translate('shared.invoices.invoice-name.master-ref-number');
      case 'DEBT_INTEREST':
        return translate('shared.invoices.invoice-name.debt-interest');
      default:
        return translate('shared.invoices.invoice-name.other');
    }
  }

  public invoiceIconName(contentType: ContentType): string {
    switch (contentType) {
      case 'MOBILE':
        return '#phone';
      case 'BROADBAND':
        if (this.ssoStore.isPrivateCustomer) {
          return '#home';
        } else {
          return '#business-services';
        }
      default:
        return '#file-bill';
    }
  }
}
